<template>
	<div>
		<!-- Header -->
		<div class="flex xs-12 mb2 xs-middle" slot="headline">
			<div class="flex xs-6 xs-left fs5 lh125 fw7 c1">{{ $t("rejection_info") }}</div>
			<div class="flex xs-6 xs-right xs-middle lh125 c1">
				<!-- <j-button type="tertiary">
					<crm-icon name="edit" size="small" color="c2" />
					{{ $t("edit") }}
				</j-button>-->
			</div>
		</div>

		<!-- Body -->
		<j-card class="flex-wrap xs-12 xs-right bg4--l3 p2 c1">
			<div v-if="rejectionCodes.length > 0" class="fw7 fs3 c1 mb2">{{ `${$t("reasons")}:` }}</div>
			<ul class="pl6">
				<li class="mb1 fs3 lh125" v-for="(item, i) in rejectionCodes" :key="i">{{ `${item.code} - ${item.name}` }}</li>
			</ul>
			<div v-if="rejectionRemarks !== null" class="xs-12 fw7 fs3 c1 mt4 lh125">{{ `${$t("remarks")}:` }}</div>
			<p class="xs-12 fs3 lh125">{{ rejectionRemarks }}</p>
		</j-card>
	</div>
</template>

<script>
import CoreModal from "@/modules/core/components/CoreModal"
import CoreFormInput from "@/modules/core/components/CoreFormInput"
import JCard from "@/components/JCard"
import JButton from "@/components/JButton"
import CrmIcon from "@/components/CrmIcon"
import get from "lodash.get"
import api from "../api/"

/**
 * This component is responsible for numerous actions that can happen on policy
 * It's a smart component that is calling APIs
 */
export default {
	components: { JCard, JButton, CoreModal, CoreFormInput, CrmIcon },

	props: {
		rejectionCodes: Array,
		rejectionRemarks: String
	},

	data() {
		return {
			rejectionReasons: [],
			rejectionOptions: [],
			remarks: null
		}
	},

	methods: {
		massageRejectionReasons() {
			return this.rejectionOptions.filter(option => {
				return this.rejectionReasons.includes(option.value)
			})
		}
	},

	created() {}
}
</script>